var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "neu-cards-slider-general" },
    [
      _c(
        "b-row",
        { staticClass: "centered d-flex neu-cards-slider-general-funct" },
        [
          _vm.signUpVisible
            ? _c(
                "base-modal",
                {
                  ref: "signUpModal",
                  attrs: { title: _vm.$t("sign-up"), hideClose: "" },
                  model: {
                    value: _vm.signUpVisible,
                    callback: function($$v) {
                      _vm.signUpVisible = $$v
                    },
                    expression: "signUpVisible"
                  }
                },
                [
                  _c("patient-signup-form", {
                    attrs: {
                      callback: function() {
                        _vm.signUpVisible = false
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.blackTitle != null || _vm.hasHeadingSlot
            ? _c(
                "b-col",
                {
                  staticClass: "text-center pt-lg-0 d-inline-block",
                  attrs: { cols: "12" }
                },
                [
                  !_vm.hasHeadingSlot
                    ? _c("div", { staticClass: "my-auto" }, [
                        _vm.blackTitle
                          ? _c(
                              "h2",
                              {
                                staticClass:
                                  "mobile-font mx-3 mx-md-0 mt-5 mt-md-0 my-md-5",
                                class: {
                                  "my-5":
                                    _vm.typeTitle != "principal" &&
                                    !_vm.$uiHelpers.isFullMobile
                                },
                                staticStyle: {
                                  display: "inline-block",
                                  "font-size": "35px"
                                }
                              },
                              [_vm._v(_vm._s(_vm.blackTitle))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.typeTitle === "principal" ? _c("br") : _vm._e(),
                        _vm.title != null
                          ? _c(
                              "h3",
                              {
                                staticClass: "mobile-font",
                                class: { "my-5": !_vm.$uiHelpers.isFullMobile },
                                staticStyle: {
                                  "font-size": "35px",
                                  display: "inline-block"
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.title))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.subtitle != null
                          ? _c(
                              "h4",
                              {
                                staticClass: "mobile-font",
                                class: {
                                  "my-2 mx-5": !_vm.$uiHelpers.isFullMobile,
                                  "mx-2": !_vm.$uiHelpers.isFullMobile
                                },
                                staticStyle: {
                                  "font-size": "25px",
                                  display: "inline-block",
                                  color: "#3238C4"
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.subtitle))]
                            )
                          : _vm._e()
                      ])
                    : _c("div", [_vm._t("heading")], 2)
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("carousel2", {
            staticClass: "d-none d-touch-screens-block",
            attrs: {
              cards: _vm.cards.filter(function(e) {
                return (
                  (!_vm.inMx && (e.es || true) === true) ||
                  (_vm.inMx && e.mx === true)
                )
              }),
              type: _vm.type,
              iconColor: _vm.iconsColor
            }
          }),
          _vm._v(" "),
          _c(
            "carousel-3d",
            {
              staticClass: "d-block d-touch-screens-none mb-5 mb-md-0",
              attrs: { height: 350, border: 0 }
            },
            _vm._l(
              _vm.cards.filter(function(e) {
                return (
                  (!_vm.inMx && (e.es || true) === true) ||
                  (_vm.inMx && e.mx === true)
                )
              }),
              function(professional, i) {
                return _c("slide", {
                  key: i,
                  staticStyle: { "background-color": "transparent" },
                  attrs: { index: i },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var index = ref.index
                          var isCurrent = ref.isCurrent
                          var leftIndex = ref.leftIndex
                          var rightIndex = ref.rightIndex
                          return [
                            professional.type == 0
                              ? _c("neu-card-general", {
                                  class: {
                                    current: isCurrent,
                                    onLeft: leftIndex >= 0,
                                    onRight: rightIndex >= 0
                                  },
                                  attrs: {
                                    "data-index": index,
                                    src: professional.src,
                                    title: professional.title,
                                    subtitle: professional.subtitle,
                                    titleLines: 1,
                                    subtitleLines: 1
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            professional.type == 2
                              ? _c("neu-card-general", {
                                  class: {
                                    current: isCurrent,
                                    onLeft: leftIndex >= 0,
                                    onRight: rightIndex >= 0
                                  },
                                  attrs: {
                                    "data-index": index,
                                    src: professional.src,
                                    link: professional.link,
                                    title: professional.title,
                                    titleLines: professional.titleLines,
                                    iconColor: _vm.iconsColor
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            professional.type == null
                              ? _c("neu-card-big-text", {
                                  class: {
                                    current: isCurrent,
                                    onLeft: leftIndex >= 0,
                                    onRight: rightIndex >= 0
                                  },
                                  attrs: {
                                    "data-index": index,
                                    src: professional.src,
                                    title: professional.title,
                                    subtitle: professional.subtitle,
                                    titleLines: professional.titleLines,
                                    subtitleLines: professional.subtitleLines,
                                    iconColor: _vm.iconsColor
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }
            ),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-291a644f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291a644f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/NeuCardsSlider2.vue
// module id = 2486
// module chunks = 10 12 30 31 35 36 39 40 41 42 44 49 51 59